import React from 'react'

const CalculatorColumnBottomLeft = (props) => {
    return (
        <div className='calculator-box__column-bottom-left'>
            {props.children}
        </div>
    )
}

export default CalculatorColumnBottomLeft